import { useConfirmationDialog } from '@goodfynd/ui';
import { useSubscriptionApi } from '@hooks/api/account/useSubscriptionApi/useSubscriptionApi';
import { usePostApi } from '@hooks/api/usePostApi';
import type {
  ActiveSubscriptionItem,
  SaasProduct,
  SubscriptionUpdate,
} from 'types/account/subscriptions';
import type { PostApiOptions } from 'types/api';

export function useUpdateSubscription(
  organizationId: string,
  subscriptionId?: string,
  options?: Partial<PostApiOptions<ActiveSubscriptionItem, SubscriptionUpdate>>
) {
  const api = useSubscriptionApi();
  const { getConfirmation } = useConfirmationDialog();

  const { post: updateSubscription, isPosting: isUpdatingSubscription } =
    usePostApi({
      getSuccessMessage: () => 'Subscription updated!',
      request: (params) => api.updateSubscription(organizationId, params),
      ...options,
    });

  return {
    isUpdatingSubscription,
    updateSubscription: async (
      item: SaasProduct,
      priceId: string,
      paymentMethodId: string
    ) => {
      if (
        !subscriptionId ||
        !(await getConfirmation({
          title: 'Update subscription',
          message: `Are you sure you want to change your plan to the ${item.name}?`,
          confirmButtonText: 'Update',
        }))
      ) {
        return;
      }

      return updateSubscription({
        paymentMethodId,
        priceId,
        subscriptionId,
      });
    },
  };
}
